<script>
    export default {
        props: {
            'data': {
                type: Object,
                default: function(){ return {} },
            },
            'origin': {
                type: String,
                default: null,
            },
            'locked': {
                type: Boolean,
                default: false,
            },
            'container': {
                type: Number,
                default: 0
            },
            'tree': {
                type: Array,
                default: function () { return [] }
            },
            'description': {
                default: '',
                type: String,
            },
            'dragged': {
                validator: function() { return true },
                default: false,
            },
            'active': {
                type: Boolean,
                default: false, 
            },
            'triggered': {
                type: Boolean,
                default: false, 
            },
            'unselectable': {
                type: Boolean,
                default: false,
            }
        },
        data: function () {
            return {
                isHovered: false,
                isEdited: false,
                isForced: false,
            }
        },
        mounted: function() {
            Vue.set(this.$root.componentRefs, this.data.id, this);
        },
        beforeDestroy: function() {
            Vue.delete(this.$root.componentRefs, this.data.id);
        },
        methods: {
            highlightOn: function(e) {
                if (this.unselectable) {
                    return false;
                }

                if (!this.$root.editorActive && !window.mouseBtnPressed) {
                    this.isHovered = this.data.id;
                }
            },
            highlightOff: function(e) {
                if (this.unselectable) {
                    return false;
                }

                if (e) {
                    for (let el of this.$children) {
                        if (el.$el.contains(e.relatedTarget)) {
                            this.isHovered = false;
                            return false;
                        }
                    }

                    if (this.$el.contains(e.relatedTarget)) {
                        return false;
                    }
                }

                this.isHovered = false;
                return false;
            },
            triggerFocus: function(e, id) {
                let cmp = this;
                let resize = false;

                this.isHovered = false;

                if (e) {
                    resize = e.target.classList.contains('control');
                }

                if (id == this.data.id) {
                    e.stopPropagation();
                }

                setTimeout( function() {
                    if (cmp.$root.editorActive) {
                        return false;
                    }
                    if (!window.mouseBtnPressed) {
                        cmp.unfocus(cmp.$root.editorActive, e);
                        cmp.enterEditMode(e);
                    } else {
                        if (resize) {
                            window.resizeActive = true;
                        } else {
                            window.dragActive = true;
                        }
                    }
                }, 350);

            },
            focus: function(id, event) {
                if (id == this.data.id) this.selected=true;
                this.$emit('focus', id, event);
            },
            unfocus: function(id, event) {
                this.selected=false;
                this.$emit('unfocus', id, event);
            },
            remove: function(id, event) {
                this.$emit('remove', id, event);
            },
            dragstart: function(id, name, event) {
                this.$emit('dragstart', id, name, event);
            },
            dragend: function(event) {
                this.$emit('dragend', event);
            },
            update: function(id, data, event) {
                Vue.set(this.$root.componentRefs, this.data.id, this);
                this.$emit('update', id, data, event);
            },
            copy: function() {
                this.$emit('update', this.data.id, this.data, 'duplicate');
            },
            enterEditMode: function(event) {
                if (this.isEdited) {
                    return;
                }

                this.isEdited = true;


                document.addEventListener('mousedown', this.leaveEditMode, true);

                this.focus(this.data.id, event);
            },
            leaveEditMode: function(event) {
                const dialog = document.getElementsByClassName('dg-content');

                if (this.$el.contains(event.target) || event.target.classList.contains('control')) {
                    return;
                }

                if (dialog.length > 0 && dialog[0].contains(event.target)) {
                    return;
                }

                this.isEdited= false;

                document.removeEventListener('mousedown', this.leaveEditMode, true);

                this.unfocus(this.data.id, event);
            },
            updateStyles: function(data) {
                this.update(this.data.id, {'style': data});
                this.$forceUpdate();
            },
        },
    }
</script>
